// API Configuration for different environments
const config = {
  development: {
    API_BASE_URL: 'http://localhost:8000'
  },
  production: {
    API_BASE_URL: 'https://chat-website-uai.uc.r.appspot.com'
  },
  preview: {
    API_BASE_URL: process.env.REACT_APP_PREVIEW_BACKEND_URL || 'https://chat-website-uai.uc.r.appspot.com'
  }
};

// Determine environment
const hostname = window.location.hostname;
const isFirebaseHosting = hostname.includes('.web.app') || hostname.includes('.firebaseapp.com');
const isPreviewMode = process.env.REACT_APP_PREVIEW_MODE === 'true';

let environment;
if (isPreviewMode) {
  environment = 'preview';
} else if (isFirebaseHosting) {
  environment = 'production';
} else {
  environment = process.env.NODE_ENV || 'development';
}

// Get the API base URL
const selectedConfig = config[environment];
const API_BASE_URL = selectedConfig?.API_BASE_URL || config.production.API_BASE_URL;

// Export the config
const appConfig = {
  API_BASE_URL,
  environment,
  isPreviewMode
};

export default appConfig;
export { API_BASE_URL };

// Agent Tutor is temporarily held behind a "Coming Soon" state for all roles.
// Flip to false to restore the full feature — no other code changes needed.
export const AGENT_TUTOR_COMING_SOON = true;
